import {
  EuiFlexGroup,
  EuiPanel,
  EuiTitle,
  EuiSpacer,
  EuiStat,
} from "@inscopix/ideas-eui";
import { IconComputeCredits } from "components/IconComputeCredits/IconComputeCredits";
import { isEqual } from "lodash";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { filesize } from "utils/filesize";
import { roundToSignificant } from "utils/roundToSignificant";

/*
 * Project page sidebar panel with resource consumption information
 */
export const ToolPanelResources = () => {
  const project = useDataTableContext((s) => {
    const project = s.project;
    return {
      activeStorageSize: project.active_storage_size,
      archivedStorageSize: project.archived_storage_size,
      usedCredits: project.used_credits,
    };
  }, isEqual);

  return (
    <EuiPanel
      hasBorder={false}
      hasShadow={false}
      paddingSize="s"
      style={{ flexGrow: "0" }}
    >
      <EuiTitle size="s">
        <span>Test Resources</span>
      </EuiTitle>
      <EuiSpacer size="s" />
      <EuiStat
        key="active-storage-size"
        titleSize={"xs"}
        title={filesize(project.activeStorageSize ?? "0")}
        description="Active storage"
        reverse
      />
      <EuiSpacer size="s" />
      <EuiStat
        key="compute-credits"
        titleSize={"xs"}
        titleElement="div"
        title={
          <EuiFlexGroup alignItems="baseline" gutterSize="s">
            {roundToSignificant(project.usedCredits ?? 0)}{" "}
            <IconComputeCredits />
          </EuiFlexGroup>
        }
        description={"Compute credits"}
        reverse
      />
    </EuiPanel>
  );
};
